module.exports = __webpack_public_path__ + "static/doc-19a5bf4aa4bc13dc7308d03705433f0d.png";